import React, { useState, useEffect } from "react";
import styles from "./Packet.module.scss";
import Header from "../header/header";
import { FaEye } from "react-icons/fa";
import { CustomSpinner } from "../shared/Spinner";
import { db } from "../../firebase";

export default function ProPacketPage() {
  const [loading, setLoading] = useState(false);
  const [packetData, setPacketData] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 768;

  const handleRowClick = (pdfUrl) => {
    if (isMobile) {
      window.open(pdfUrl, '_blank', 'noopener,noreferrer');
    }
  };

  useEffect(() => {
    getPacketData();
  }, []);

  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${month}/${day}/${year}`;
  };

  const getPacketData = async () => {
    setLoading(true);
    try {
      const response = await db.collection("pi-packets").get();
      const data = response.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
      data.sort((a, b) => new Date(b.date) - new Date(a.date));
      setPacketData(data);
      setLoading(false);
    } catch (error) {
      console.log(error, "error");
      setLoading(false);
    }
  };

  if (loading) {
    return <CustomSpinner />;
  }

  if (!packetData && !loading) {
    return <div>Loading Packet data</div>;
  }

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.content}>
        <div className={styles.title}>
          <h4>PI Packets Library</h4>
          <p>This section contains our archived collection of PI Packets</p>
        </div>
        <hr />
        <div className={`${styles.table} ${isMobile ? styles.mobileTable : ''}`}>
          <div className={styles.tableHeader}>
            
          </div>
          <div className={`${styles.row} ${isMobile ? styles.mobileHeader : ''}`}>
            <div>Event</div>
            <div>Date</div>
            <div>View</div>
          </div>
          {packetData.map((item) => (
            <div 
              key={item.id} 
              className={`${styles.row} ${isMobile ? styles.mobileRow : ''}`}
              onClick={() => handleRowClick(item.pdfUrl)}
              style={{ cursor: isMobile ? 'pointer' : 'default' }}
            >
              <div>{item.title}</div>
              <div>{formatDate(item.date)}</div>
              <div>
                {!isMobile && (
                  <a
                    href={item.pdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaEye style={{ color: "grey", marginRight: "5px" }} />
                  </a>
                )}
                {isMobile && (
                  <FaEye style={{ color: "grey", marginRight: "5px" }} />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
